<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation (Mobile) -->
@if (isScreenSmall) {
  <nav aria-label="Mobile navigation">
    <fuse-vertical-navigation class="dark bg-gray-900 print:hidden" [mode]="'over'" [name]="'mainNavigation'"
      [navigation]="navigation.default" [opened]="false">
      <!-- Navigation header hook -->
      <ng-container fuseVerticalNavigationContentHeader>
        <!-- Logo -->
        <div class="flex items-center h-20 pt-6 px-8">
          <img class="w-10" src="assets/images/logo/eprint-logo.svg" alt="Logo image">
        </div>
      </ng-container>
    </fuse-vertical-navigation>
  </nav>
}

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">

  <!-- Header -->
  <header aria-label="Page header" class="relative flex flex-0 items-center w-full h-16 sm:h-20 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
    @if (!isScreenSmall) {
      <!-- Logo -->
      <div class="flex items-center">
        <!-- <div class="hidden lg:flex">
        <img
          class="dark:hidden w-10"
          src="assets/images/logo/eprint-logo.svg">
          <img
            class="hidden dark:flex w-10"
            src="assets/images/logo/eprint-logo.svg">
          </div>
          <img
            class="flex lg:hidden w-10"
            src="assets/images/logo/eprint-logo.svg"> -->
            <img class="w-[120px] pl-[20px] h-full object-contain" src={{customerLogo}} alt="Logo image">
          </div>
          <!-- Horizontal navigation -->
          <nav aria-label="Main navigation"
            class="mr-2"><fuse-horizontal-navigation [name]="'mainNavigation'" [navigation]="navigation.horizontal">
          </fuse-horizontal-navigation>
        </nav>
      }
      <!-- Navigation toggle button -->
      @if (isScreenSmall) {
        <button mat-icon-button id="modernCmp_toggleNavBtn" aria-label="Toggle navigation menu" (click)="toggleNavigation('mainNavigation')">
          <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
        </button>
      }

      <!-- Components -->
      <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">
        <app-languages></app-languages>
        <user></user>
      </div>
    </header>

    <!-- Breadcrumb -->
    <div class="w-full h-12">
      <app-breadcrumb [breadCrumbConfig]="breadCrumbConfig"></app-breadcrumb>
    </div>

    <!-- Main Content -->
    <div aria-label="Main content" class="flex flex-col flex-auto w-full">
      <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
      Otherwise, layout changes won't be registered and the view won't be updated! -->
      @if (true) {
        <router-outlet></router-outlet>
      }
    </div>

    <!-- Footer -->
    <footer aria-label="Page footer"
      class="relative flex flex-0 items-center w-full h-14 sm:h-20 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
      <span class="font-medium text-secondary">ePRINTit &copy; {{currentYear}}</span>
    </footer>

  </div>
